// Kizárólag MEGJELENÍTÉSI célú segédfüggvény: a hosszabbítás-periódusok
// feliratát ("Első hosszabbítás I. félidő" -> "O.T. Első I. félidő") rövidíti
// a CR/DMR/SUB felületeken. FONTOS: ez sosem módosíthatja a ténylegesen
// tárolt/szinkronizált adatot (gamedata.periods, az "init" rekord stb.) -
// azt a LiveScore (és a hivatalos jegyzőkönyv-adat) is felhasználja, aminek
// az EREDETI, teljes feliratot kell mutatnia. Ezt a függvényt csak ott
// szabad hívni, ahol a szöveget ténylegesen KIÍRJUK a képernyőre, sosem ott,
// ahol az eredményt visszaírnánk egy megosztott/szinkronizált objektumba.
export function shortenPeriodText(text) {
    if (typeof text !== 'string') return text;
    return text
        .replace('Első hosszabbítás', 'O.T. 1')
        .replace('Második hosszabbítás', 'O.T. 2');
}
